<template>
    <div>

        <headline>
            Ausstattung
            <template slot="more">
                <equipment-create @created="load" class="mr-2"></equipment-create>
                <postable-equipment-create @created="load"></postable-equipment-create>
            </template>
        </headline>

        <loading v-show="loading"></loading>

        <div v-show="equipment.length === 0 && postableEquipment.length === 0 && !loading">
            Keine Ausstattung gefunden. Jetzt Ausstattung hinzufügen.
            <div class="flex">
            <equipment-create @created="load" class="mr-2"></equipment-create>
            <postable-equipment-create @created="load"></postable-equipment-create>
            </div>
        </div>

        <div class="mb-8">

            <h2 class="text-lg leading-6 font-medium text-gray-900">Ausstattung</h2>

            <tailwind-table v-show="equipment.length > 0" :header="['Name', '']">
                <tr v-for="(equipment,i) in equipment" :class="{'bg-gray-50': i%2}">
                    <td class="px-6 py-3">{{ equipment.name }}</td>
                    <td class="px-6 py-3 flex justify-end items-center">
                        <equipment-edit class="mr-2" :equipment="equipment" @updated="load"></equipment-edit>
                    </td>
                </tr>
            </tailwind-table>

        </div>

        <div class="mb-8">

            <h2 class="text-lg leading-6 font-medium text-gray-900">Zubuchbare Ausstattung</h2>

            <tailwind-table v-show="postableEquipment.length > 0" :header="['Name', 'Anzahl', '']">
                <tr v-for="(equipment,i) in postableEquipment" :class="{'bg-gray-50': i%2}">
                    <td class="px-6 py-3">{{ equipment.name }}</td>
                    <td class="px-6 py-3">{{ equipment.quantity }}</td>
                    <td class="px-6 py-3 flex justify-end items-center">
                        <postable-equipment-edit class="mr-2" :equipment="equipment"
                                                 @updated="load"></postable-equipment-edit>
                    </td>
                </tr>
            </tailwind-table>
        </div>
    </div>
</template>

<script>
import Loading from "../components/UI/Loading.vue";
import Headline from "../components/UI/Headline.vue";
import EquipmentCreate from "../components/Equipment/EquipmentCreate.vue";
import TailwindTable from "../components/UI/TailwindTable.vue";
import EquipmentEdit from "../components/Equipment/EquipmentEdit.vue";
import EquipmentDelete from "../components/Equipment/EquipmentDelete.vue";
import PostableEquipmentEdit from "../components/PostableEquipment/PostableEquipmentEdit.vue";
import PostableEquipmentDelete from "../components/PostableEquipment/PostableEquipmentDelete.vue";
import PostableEquipmentCreate from "../components/PostableEquipment/PostableEquipmentCreate.vue";

export default {
    name: "Equipment",
    components: {
        PostableEquipmentCreate,
        PostableEquipmentDelete,
        PostableEquipmentEdit,
        EquipmentDelete, EquipmentEdit, TailwindTable, EquipmentCreate, Headline, Loading
    },

    data: () => ({
        loading: false,
        equipment: [],
        postableEquipment: [],
    }),

    created() {
        this.load();
    },

    methods: {
        load() {
            this.loadEquipment();
        },
        loadEquipment() {
            this.loading = true;
            this.$http.get('/admin/equipment')
                .then(result => {
                    this.loading = false;
                    this.equipment = result.data.data;
                    this.loadPostableEquipment();
                }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
        loadPostableEquipment() {
            this.loading = true;
            this.$http.get('/admin/postable_equipment')
                .then(result => {
                    this.loading = false;
                    this.postableEquipment = result.data.data;
                }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    },
}
</script>

<style scoped>

</style>
